import api from './api';

export const searchService = {
  async globalSearch(query, limit = 10) {
    const response = await api.get('/search', {
      params: { q: query, limit }
    });
    return response.data;
  }
};
